import React from "react";
import { Link } from "react-router-dom";
import Nav from "../components/landing/Nav";
import Footer from "../components/landing/Footer";
import { BLOG_POSTS } from "../data/content";
import { ArrowUpRight } from "lucide-react";

function formatDate(d) {
    try {
        return new Date(d).toLocaleDateString("en-NZ", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    } catch {
        return d;
    }
}

export default function BlogIndex() {
    const [featured, ...rest] = BLOG_POSTS;
    return (
        <div className="min-h-screen bg-page text-ink" data-testid="blog-index-page">
            <Nav />
            <main>
                <section className="relative overflow-hidden border-b border-hairline py-20 lg:py-28">
                    <div className="pointer-events-none absolute -top-10 right-0 h-80 w-80 animate-blob rounded-full bg-sun/15 blur-3xl" />
                    <div className="relative mx-auto max-w-[1400px] px-5 lg:px-10">
                        <div className="mb-4 text-xs font-bold uppercase tracking-[0.22em] text-coral">
                            // The journal
                        </div>
                        <h1 className="font-display text-5xl font-black leading-[0.95] tracking-tight text-ink sm:text-6xl lg:text-7xl">
                            Notes &amp;{" "}
                            <span className="font-serif italic font-normal text-coral">
                                playbooks.
                            </span>
                        </h1>
                        <p className="mt-8 max-w-2xl text-base leading-relaxed text-ink/75 lg:text-lg">
                            Short, useful reads for small business owners. No clickbait. No
                            corporate sludge. Just the stuff we wish someone told us in year one.
                        </p>
                    </div>
                </section>

                <section className="border-b border-hairline bg-page py-14 lg:py-20">
                    <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
                        {/* Featured */}
                        <Link
                            to={`/blog/${featured.slug}`}
                            className="group block border-2 border-ink/15 bg-white p-8 transition-all hover:-translate-y-1 hover:frame-coral lg:p-12"
                            data-testid={`blog-card-${featured.slug}`}
                        >
                            <div className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.22em] text-coral">
                                <span>Featured</span>
                                <span className="text-ink/35">·</span>
                                <span className="text-ink/55">{featured.category}</span>
                                <span className="text-ink/35">·</span>
                                <span className="text-ink/55">{featured.readingTime}</span>
                            </div>
                            <h2 className="mt-5 font-display text-3xl font-black leading-tight tracking-tight text-ink lg:text-5xl">
                                {featured.title}
                            </h2>
                            <p className="mt-4 max-w-2xl text-base leading-relaxed text-ink/75 lg:text-lg">
                                {featured.excerpt}
                            </p>
                            <div className="mt-6 inline-flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wider text-coral">
                                Read the post
                                <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                            </div>
                        </Link>

                        {/* Grid */}
                        <div className="mt-8 grid gap-5 lg:grid-cols-3">
                            {rest.map((p, i) => (
                                <Link
                                    key={p.slug}
                                    to={`/blog/${p.slug}`}
                                    className={`group flex flex-col justify-between border-2 border-ink/15 bg-white p-6 transition-all hover:-translate-y-1 ${
                                        i === 0
                                            ? "hover:frame-sun"
                                            : i === 1
                                              ? "hover:frame-coral"
                                              : "hover:frame"
                                    } lg:p-7`}
                                    data-testid={`blog-card-${p.slug}`}
                                >
                                    <div className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.22em] text-coral">
                                        <span>{p.category}</span>
                                        <span className="text-ink/35">·</span>
                                        <span className="text-ink/55">{p.readingTime}</span>
                                    </div>
                                    <h3 className="mt-4 font-display text-xl font-bold leading-tight text-ink lg:text-2xl">
                                        {p.title}
                                    </h3>
                                    <p className="mt-3 text-sm leading-relaxed text-ink/70">
                                        {p.excerpt}
                                    </p>
                                    <div className="mt-6 flex items-center justify-between border-t border-ink/10 pt-4 text-xs uppercase tracking-widest text-ink/55">
                                        <span>{formatDate(p.date)}</span>
                                        <ArrowUpRight className="h-4 w-4 text-coral transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
